import React, { useState } from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { ConstantService } from "../../../../services/ConstantService";
import { Helpers } from "../../../../helpers/Helpers";
import Box from "../../../../components/Box";
import { GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField } from "../../../../models/response/ambarAgreementScheme/GetAmbarAgreementSchemeByIdResponse";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";
import CustomSwitch from "../../../../components/CustomSwitch";

interface Props {
    fieldInformationRef: any
    ambarAgreementSchemeFields: GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField[]
    setAmbarAgreementSchemeFields: React.Dispatch<React.SetStateAction<GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField[]>>
}

const FieldDetails = ({
    fieldInformationRef,
    setAmbarAgreementSchemeFields,
    ambarAgreementSchemeFields
}: Props) => {
    const dispatch = useDispatch();
    const [ambarAgreementSchemeFieldId, setAmbarAgreementSchemeFieldId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedField, setSelectedField] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOperator, setSelectedOperator] = useState<CustomSingleSelectModel | undefined>(undefined);

    const saveItem = () => {
        if (Helpers.isEmpty(ambarAgreementSchemeFieldId)) {
            var o: GetAmbarAgreementSchemeByIdResponseAmbarAgreementSchemeField = {
                ambarAgreementSchemeFieldId: Helpers.generateUUID(true),
                isSelected: false,
                fieldId: selectedField?.value,
                fieldName: selectedField?.label,
                operatorId: selectedOperator?.value,
                operatorName: selectedOperator?.label,
            }

            setAmbarAgreementSchemeFields([...ambarAgreementSchemeFields, o])
        }
        else {
            setAmbarAgreementSchemeFields(ambarAgreementSchemeFields.map(function (x) {
                if (x.ambarAgreementSchemeFieldId == ambarAgreementSchemeFieldId) {
                    x.isSelected = false;
                    x.fieldId = selectedField?.value;
                    x.fieldName = selectedField?.label;
                    x.operatorId = selectedOperator?.value;
                    x.operatorName = selectedOperator?.label;
                }

                return x;
            }))
        }

        setAmbarAgreementSchemeFieldId('');
        setSelectedField(undefined);
        setSelectedOperator(undefined);

        setIsOpen(false);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setAmbarAgreementSchemeFields(ambarAgreementSchemeFields.map(function (x) {
            if (x.ambarAgreementSchemeFieldId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAmbarAgreementSchemeFieldId('');
        setSelectedField(undefined);
        setSelectedOperator(undefined);

        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = ambarAgreementSchemeFields.filter(x => x.isSelected)[0];

        setAmbarAgreementSchemeFieldId(o.ambarAgreementSchemeFieldId);
        setSelectedField(o.fieldId && o.fieldName ? { label: o.fieldName, value: o.fieldId } : undefined);
        setSelectedOperator(o.operatorId && o.operatorName ? { label: o.operatorName, value: o.operatorId } : undefined);

        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = async () => {
        setAmbarAgreementSchemeFields(ambarAgreementSchemeFields.filter(x => !x.isSelected));
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = fieldInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const selectAll = () => {
        var isAllSelected = ambarAgreementSchemeFields.length == ambarAgreementSchemeFields.filter(x => x.isSelected).length;

        setAmbarAgreementSchemeFields(ambarAgreementSchemeFields.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={fieldInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Eşleştirme Alanları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Alan"
                                            isLabelRequired
                                            selectedValue={selectedField}
                                            onChange={setSelectedField}
                                            onMenuOpen={() => ConstantService.getConstantList('AMBAR_AGREEMENT_SCHEME_FIELD')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Operatör"
                                            isLabelRequired
                                            selectedValue={selectedOperator}
                                            onChange={setSelectedOperator}
                                            onMenuOpen={() => ConstantService.getConstantList('LOGIC_OPERATOR')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarAgreementSchemeFields.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={ambarAgreementSchemeFields.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarAgreementSchemeFields.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={ambarAgreementSchemeFields.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={ambarAgreementSchemeFields.filter(x => x.isSelected).length > 0 && ambarAgreementSchemeFields.filter(x => x.isSelected).length == ambarAgreementSchemeFields.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Alan</th>
                                            <th>Operatör</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            ambarAgreementSchemeFields.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            ambarAgreementSchemeFields.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.ambarAgreementSchemeFieldId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.fieldName}</td>
                                                    <td>{item.operatorName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default FieldDetails;